// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createSpecialAllowanceClaimStatus} from '../../shared/repositories';
import {getSpecialAllowanceClaimStatusReportCriteria} from '../../shared/services/reports';

export const createSpecialAllowanceClaimStatusReport = tabm =>
    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const specialAllowanceClaimStatusCriteria = getState().reports.specialAllowanceClaimStatus.criteria;

            const postArgs = getSpecialAllowanceClaimStatusReportCriteria(specialAllowanceClaimStatusCriteria);

            const data = await createSpecialAllowanceClaimStatus(postArgs, tabm);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_SPECIAL_ALLOWANCE_CLAIM_STATUS_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/action-creators/report.js